module.exports = __webpack_public_path__ + "img/emergency_medicine_anesthesia.0b39788d.svg";